/* tslint:disable */
import {
  HttpClient,
  HttpContext,
  HttpHeaders,
  HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import { PaginatedList } from '../../models/paginator/paginated-list';
import { AdminQuestionnaireInstanceModel } from '../../models/admin-questionnaire-instance-model';

export type AdminQuestionnaireInstanceStatus =
  | 'Initialised'
  | 'Started'
  | 'Resumed'
  | 'Finished'
  | 'FinishedEarly'
  | 'Declined';

export type AdminQuestionnaireInstanceSortKey =
  | 'createdAt'
  | 'modifiedAt'
  | 'startedAt'
  | 'invitedAt'
  | 'questionnaireName'
  | 'currentQuestionName'
  | 'surveyRespondentName'
  | 'status'
  | 'platform'
  | 'isTest'
  | 'hasAlerts'
  | 'accountName';

export interface QuestionnaireInstancesAdminGetParams {
  accountGuid?: string;
  status?: AdminQuestionnaireInstanceStatus;
  isTest?: boolean;
  hasAlerts?: boolean;
  search?: string;
  pageNumber?: number;
  pageSize?: number;
  sortKey?: AdminQuestionnaireInstanceSortKey;
  sortDirection?: 'asc' | 'desc';
}

export function questionnaireInstancesAdminGet(
  http: HttpClient,
  rootUrl: string,
  params: QuestionnaireInstancesAdminGetParams,
  headers: HttpHeaders,
  context?: HttpContext,
): Observable<
  StrictHttpResponse<PaginatedList<AdminQuestionnaireInstanceModel>>
> {
  const rb = new RequestBuilder(
    rootUrl,
    questionnaireInstancesAdminGet.PATH,
    'get',
  );

  for (const headerKey of headers.keys()) {
    rb.header(headerKey, headers.get(headerKey));
  }

  rb.query('accountGuid', params.accountGuid);
  rb.query('status', params.status);
  rb.query('isTest', params.isTest);
  rb.query('hasAlerts', params.hasAlerts);
  rb.query('search', params.search);
  rb.query('pageNumber', params.pageNumber);
  rb.query('pageSize', params.pageSize);
  rb.query('sortKey', params.sortKey);
  rb.query('sortDirection', params.sortDirection);

  return http
    .request(rb.build({ responseType: 'json', accept: '*/*', context }))
    .pipe(
      filter(
        (r: unknown): r is HttpResponse<unknown> => r instanceof HttpResponse,
      ),
      map((r: HttpResponse<unknown>) => {
        return r as StrictHttpResponse<
          PaginatedList<AdminQuestionnaireInstanceModel>
        >;
      }),
    );
}

questionnaireInstancesAdminGet.PATH = '/api/v1/questionnaire-instances/admin';
